module.exports = __webpack_public_path__ + "static/media/idea.dfd95af5.svg";